/* eslint-disable react/no-find-dom-node */
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { FlexLayout, FlexItem, RadioGroup } from '@waca/ca-ui-toolkit';
import stringResource from 'ba-filter-nls';

export default class OperatorSelector extends Component<any, any> {
	// Define properties and types
	static propTypes = {
		operator: PropTypes.string,
		onChange: PropTypes.func.isRequired,
	};

	// Define default property values
	static defaultProps = {
		operator: 'and',
	};

	componentDidMount() {
		const node = findDOMNode(this.radioGroup) as HTMLElement;

		node && node.focus();
	}

	radioGroup: RadioGroup;

	render() {
		const { onChange, operator } = this.props;
		const radioOptions = [
			{ label: stringResource.get('and'), value: 'and' },
			{ label: stringResource.get('or'), value: 'or' },
		];

		return (
			<FlexLayout direction="row">
				<FlexItem gutter={[0, 3, 0, 0]}>
					<RadioGroup
						ref={radioGroup => {
							this.radioGroup = radioGroup;
						}}
						checked={operator}
						name="operator"
						options={radioOptions}
						selectedId={operator}
						align="left"
						direction="horizontal"
						onChange={onChange}
					/>
				</FlexItem>
			</FlexLayout>
		);
	}
}
